module.exports = __webpack_public_path__ + "img/carrousel-mamo-3.455693bb.jpg";